import { useContext } from "react";
import UserContext from "../context/user-context";
import User from "../passapp-sdk/user";
import { useStore } from "./useStore";

const useUploadImage = () => {
  const { authStore } = useStore();
  const { state } = useContext(UserContext);
  const user = new User();

  const uploadImgEvent = (
    newPhoto: any,
    field: string,
    fileName: string,
    customEventId?: string
  ) => {
    const eventId = customEventId || state.eventId;
    user.uploadImgEvent(authStore.token, newPhoto, eventId, field, fileName);
  };

  const uploadNewPhoto = (
    newPhoto: any,
    field: string,
    fileName: string,
    uploadUser?: boolean,
    customId?: string,
    customEventId?: string
  ) => {
    const id = customId || state.id;
    const eventId = customEventId || state.eventId;

    if (uploadUser) {
      user.uploadImgUser(authStore.token, newPhoto, id, field, fileName);
    }
    user.uploadImgEvent(authStore.token, newPhoto, eventId, field, fileName);
  };

  return { uploadNewPhoto, uploadImgEvent };
};
export default useUploadImage;
